import HTML from "../../HtmlHelpers";
import React from "react";
import classnames from 'classnames';

export default function NotificationTemplate({ icon, title , hint , onClick , properties , classname }) {

    return <div onClick={onClick} className={classnames(classname,'p-1')}>

        <h5>{HTML.renderIcon(icon || "fa fa-bell")} {title}</h5>
        {hint}
        <hr/>

        {properties && <dl>

            {properties.map((item,index) => (<React.Fragment key={index}>
                    <dt>{item.title}</dt>
                    <dd>{item.value}</dd>
                </React.Fragment>))}

        </dl>}

    </div>;

}


// WEBPACK FOOTER //
// ./src/common/UserNotifications/PopupTemplates/NotificationTemplate.js